import { useMutation, useQueryCache } from "react-query";
import { putNotifySubscriptionPreference } from "../../../queries/notify";
import { useAnonymousOrNormalNetworkHeaders } from "../../auth/hooks/useAnonymousOrNormalNetworkHeaders";
import { buildNotifySubscriberContactMethodsQueryKey } from "./useNotifySubscriberContactMethodsForLoggedInUser";
import { buildNotifySubscriberContactMethodQueryKey } from "./useNotifySubscriberContactMethod";

export function useNotifySubscriptionPreferenceUpdate() {
  const networkHeaders = useAnonymousOrNormalNetworkHeaders();
  const queryCache = useQueryCache();

  const [editSubscriptionPreferenceMutation, { isLoading: isEditSubscriptionPreferenceLoading }] = useMutation(
    putNotifySubscriptionPreference(networkHeaders),
    {
      onSuccess: async ({ subscriberContactMethodId }) => {
        await queryCache.invalidateQueries(
          buildNotifySubscriberContactMethodQueryKey({ id: subscriberContactMethodId }),
        );
        await queryCache.invalidateQueries(buildNotifySubscriberContactMethodsQueryKey());
      },
    },
  );

  const editSubscriptionPreference = async ({
    subscriberContactMethodId,
    subscriptionGroupId,
    type,
  }: {
    subscriberContactMethodId: number;
    subscriptionGroupId: number;
    type: "Subscribe" | "Unsubscribe";
  }) => {
    return await editSubscriptionPreferenceMutation({
      id: subscriberContactMethodId,
      body: {
        subscriptionGroupId,
        type,
      },
    });
  };

  return { editSubscriptionPreference, isEditSubscriptionPreferenceLoading };
}
